import { useAppDispatch, useAppSelector } from '../../../../lib/redux/hooks'
import { ProtocolSearch } from '../../../../ui/molecules/ProtocolSearch'
import { ProtocolSelectByObject } from '../../../../ui/molecules/ProtocolSelectByObj'
import { SelectCustom } from '../../../../ui/molecules/select'
import TextArea from '../../../../ui/molecules/textArea'
import { ConversionPeriodStateOptions } from '../../../../utils'
import { ConversionPeriodState } from '../dataService/dto'
import { setConversionPeriodCreationActiveIngredientsFound, setConversionPeriodCreationArchivedRequestNote, setConversionPeriodCreationArchivedRequestProtocolId, setConversionPeriodCreationCanceledRequestNote, setConversionPeriodCreationCanceledRequestProtocolId, setConversionPeriodCreationInspectionVisitProtocolId, setConversionPeriodCreationLastNote, setConversionPeriodCreationNote, setConversionPeriodCreationRegionResponseProtocolId, setConversionPeriodCreationRequestProtocolId, setConversionPeriodCreationSamplingResult, setConversionPeriodCreationSendingDocumentationProtocolId, setConversionPeriodCreationTrialReportProtocolId } from '../slice'
import '../styles.scss'

export function PeriodoConversioneAddForms() {
    const dispatch = useAppDispatch()
    const conversionPeriodState = useAppSelector(state => state.conversionPeriod)

    return (
        <div>
            <div className='pc-container'>
                <div className='pc-header'>
                    <div className='text-left'>
                        <span className='rid-title' style={{ color: '#d9e6e8' }}>Protocollo Richiesta</span>
                    </div>
                </div>
                <div style={{padding: '24px 24px 32px 24px'}}>
                    <ProtocolSelectByObject
                        objectId='91'
                        placeholder='Seleziona protocollo...'
                        type='entry'
                        onChange={(value) => dispatch(setConversionPeriodCreationRequestProtocolId(value))}
                        />
                </div>
            </div>

            <div className='pc-container'>
                <div className='pc-header'>
                    <div className='text-left'>
                        <span className='rid-title' style={{ color: '#d9e6e8' }}>Dettagli dei controlli effettuati</span>
                    </div>
                </div>

                <div style={{padding: '24px 24px 32px 24px'}}>
                    <div className='pb-5' style={{ display: 'flex', flex: 'wrap', gap: '24px', alignItems: 'center'}}>
                        <div style={{flex: '0.33'}}>
                            <div className="text-left">
                                <span className="input-label">Visita Ispettiva</span>
                            </div>
                            <ProtocolSelectByObject
                                objectId='103'
                                placeholder='Seleziona protocollo...'
                                type='entry'
                                onChange={(value) => dispatch(setConversionPeriodCreationInspectionVisitProtocolId(value))}
                                />
                        </div>
                        <div style={{flex: '0.33'}}>
                            <div className="text-left">
                                <span className="input-label">Rapporto di Prova</span>
                            </div>
                            <ProtocolSelectByObject
                                objectId='63'
                                placeholder='Seleziona protocollo...'
                                type='entry'
                                onChange={(value) => dispatch(setConversionPeriodCreationTrialReportProtocolId(value))}
                                />
                        </div>
                        <div style={{flex: '0.33'}}>
                            <div className="text-left">
                                <span className="input-label">Esito Prelievo</span>
                            </div>
                            <SelectCustom
                                placeholder={'Esito'}
                                options={[{value: 'Positivo', label: 'Positivo'}, {value: 'Negativo', label: 'Negativo'}]} 
                                onChange={(value) => dispatch(setConversionPeriodCreationSamplingResult(value === 'Positivo'))}
                            />
                        </div>
                    </div>

                    <div>
                        <div className="text-left">
                            <span className="input-label">Principi attivi riscontrati</span>
                        </div>
                        <TextArea
                            onChangeText={(value) => dispatch(setConversionPeriodCreationActiveIngredientsFound(value))} />
                    </div>
                </div>
            </div>

            <div className='pc-container'>
                <div className='pc-header'>
                    <div className='text-left'>
                        <span className='rid-title' style={{ color: '#d9e6e8' }}>Gestione Documentazione trasmessa alla Regione</span>
                    </div>
                </div>

                <div style={{padding: '24px 24px 32px 24px'}}>
                    <div className='pb-5' style={{borderBottomWidth: 1}}>
                        <ProtocolSearch
                            label="Protocollo Invio Documentazione"
                            type="departure"
                            onSelect={(value) => dispatch(setConversionPeriodCreationSendingDocumentationProtocolId(value))}
                        />
                    </div>
                    <div className='pt-3 pb-5'>
                        <ProtocolSearch
                            label="Protocollo Risposta Regione"
                            type="entry"
                            onSelect={(value) => dispatch(setConversionPeriodCreationRegionResponseProtocolId(value))}
                        />
                    </div>
                    <div className='pb-5' style={{borderBottomWidth: 1}}>
                        <div className="text-left">
                            <span className="input-label">Note</span>
                        </div>
                        <TextArea
                            onChangeText={(value) => dispatch(setConversionPeriodCreationNote(value))} />
                    </div>
                    <div className='pt-3 pb-5'>
                        <ProtocolSearch
                            label="Richiesta Annullata dal Cliente"
                            type="entry"
                            onSelect={(value) => dispatch(setConversionPeriodCreationCanceledRequestProtocolId(value))}
                        />
                    </div>
                    <div className='pb-5' style={{borderBottomWidth: 1}}>
                        <div className="text-left">
                            <span className="input-label">Note</span>
                        </div>
                        <TextArea
                            onChangeText={(value) => dispatch(setConversionPeriodCreationCanceledRequestNote(value))} />
                    </div>
                    <div className='pt-3 pb-5'>
                        <ProtocolSearch
                            label="Richiesta Archiviata da Codex S.r.l."
                            type="departure"
                            onSelect={(value) => dispatch(setConversionPeriodCreationArchivedRequestProtocolId(value))}
                        />
                    </div>
                    <div className='pb-5' style={{borderBottomWidth: 1}}>
                        <div className="text-left">
                            <span className="input-label">Note</span>
                        </div>
                        <TextArea
                            onChangeText={(value) => dispatch(setConversionPeriodCreationArchivedRequestNote(value))} />
                    </div>
                    <div className='pt-3 pb-5'>
                        <div className="text-left">
                            <span className="input-label">Stato / Esito</span>
                        </div>
                        <SelectCustom
                            placeholder={'Esito'}
                            options={ConversionPeriodStateOptions}
                            disabled
                            value={ConversionPeriodState.IN_CORSO}
                        />
                    </div>
                    <div className='pb-5' style={{borderBottomWidth: 1}}>
                        <div className="text-left">
                            <span className="input-label">Note</span>
                        </div>
                        <TextArea
                            onChangeText={(value) => dispatch(setConversionPeriodCreationLastNote(value))} />
                    </div>
                </div>
            </div>
        </div>
    )
}